const MetaTrader4MobileContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Intuitive Trading Interface</h4>
              </div>
              <p>
                A clean, easy-to-navigate design that lets you manage trades,
                monitor charts, and analyze price movements with zero friction.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Advanced Charting Tools</h4>
              </div>
              <p>
                Track live price data and trends with dynamic charts, 30+
                indicators, and 9 timeframes tailored for all trading
                strategies.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Instant Order Execution</h4>
              </div>
              <p>
                Execute market, pending, and stop orders in real time, even
                under high volatility, ensuring optimal entry and exit points.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Real-Time Notifications</h4>
              </div>
              <p>
                Stay ahead of every market move with push alerts and trade
                updates sent directly to your mobile device.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4MobileContentTwo;
